import { FC } from 'react'
import { Button } from '@progress/kendo-react-buttons'
import { StackLayout } from '@progress/kendo-react-layout'
import { useNavigate } from 'react-router-dom'

export const ReplyAggregationGraphFooter: FC = () => {
  const navigate = useNavigate()
  return (
    <div
      className="pcy-search-body-pane-footer pcy-control-box"
      style={{
        backgroundColor: '#FFFFFF'
      }}
    >
      <StackLayout gap={5} align={{ horizontal: 'end' }}>
        <Button onClick={() => navigate(-1)}>戻る</Button>
      </StackLayout>
    </div>
  )
}
